<template>
  <div v-if="isDevelopment" class="fixed bottom-4 right-4 z-50">
    <div class="bg-white rounded-lg shadow-xl border-2 border-yellow-400 p-4 max-w-sm">
      <!-- 标题栏 -->
      <div class="flex items-center justify-between mb-3 pb-2 border-b border-gray-200">
        <div class="flex items-center gap-2">
          <span class="text-lg">🧪</span>
          <span class="text-sm font-semibold text-gray-700">测试工具</span>
        </div>
        <button
          @click="isExpanded = !isExpanded"
          class="text-gray-500 hover:text-gray-700 transition-colors"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            stroke-width="2" 
            stroke-linecap="round" 
            stroke-linejoin="round"
            :class="{ 'rotate-180': isExpanded }"
            class="transition-transform"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
      </div>

      <!-- 展开内容 -->
      <div v-if="isExpanded" class="space-y-3">
        <!-- 快速选择选项 -->
        <div>
          <label class="block text-xs font-medium text-gray-600 mb-2">
            快速全部选择
          </label>
          <div class="grid grid-cols-4 gap-2">
            <button
              v-for="option in ['A', 'B', 'C', 'D']"
              :key="option"
              @click="fillAllWithOption(option)"
              class="px-3 py-2 text-sm font-medium rounded-md transition-colors bg-gray-100 hover:bg-gray-200 text-gray-700"
            >
              {{ option }}
            </button>
          </div>
        </div>

        <!-- 选择动物 -->
        <div>
          <label class="block text-xs font-medium text-gray-600 mb-2">
            按动物匹配答案
          </label>
          <select
            v-model="selectedAnimal"
            class="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
          >
            <option value="">-- 选择动物 --</option>
            <option
              v-for="animal in animalList"
              :key="animal"
              :value="animal"
            >
              {{ getAnimalEmoji(animal) }} {{ animal }}
            </option>
          </select>
          <button
            @click="fillWithAnimal"
            :disabled="!selectedAnimal"
            class="mt-2 w-full px-3 py-2 text-sm font-medium rounded-md transition-colors bg-yellow-400 hover:bg-yellow-500 text-white disabled:bg-gray-300 disabled:cursor-not-allowed"
          >
            填充答案
          </button>
        </div>

        <!-- 快速提交 -->
        <div class="pt-2 border-t border-gray-200">
          <button
            @click="quickSubmit"
            :disabled="answeredCount < 60"
            class="w-full px-3 py-2 text-sm font-medium rounded-md transition-colors bg-green-500 hover:bg-green-600 text-white disabled:bg-gray-300 disabled:cursor-not-allowed"
          >
            {{ answeredCount < 60 ? `快速提交 (${answeredCount}/60)` : '快速提交' }}
          </button>
        </div>

        <!-- 当前状态 -->
        <div class="pt-2 border-t border-gray-200">
          <div class="text-xs text-gray-500">
            <div>已答题: {{ answeredCount }}/60</div>
            <div>当前题目: {{ currentQuestion }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAllAnimalNames, getAnimalEmoji } from '@/data/animalArchetypes'
import { generateAnswersForAnimal, generateAnswersForOption } from '@/utils/testHelper'
import { useToast } from 'vue-toastification'

export default {
  name: 'TestQuickFill',
  props: {
    answers: {
      type: Object,
      required: true
    },
    currentQuestion: {
      type: Number,
      required: true
    }
  },
  emits: ['update-answers', 'submit'],
  data() {
    return {
      isExpanded: true,
      selectedAnimal: '',
      animalList: []
    }
  },
  computed: {
    isDevelopment() {
      return process.env.NODE_ENV === 'development'
    },
    answeredCount() {
      return Object.keys(this.answers).length
    }
  },
  mounted() {
    this.animalList = getAllAnimalNames()
  },
  methods: {
    getAnimalEmoji,
    
    /**
     * 快速填充所有答案为指定选项
     */
    fillAllWithOption(option) {
      try {
        const newAnswers = generateAnswersForOption(option)
        this.$emit('update-answers', newAnswers)
        
        const toast = useToast()
        toast.success(`已填充所有答案为 ${option}`)
      } catch (error) {
        const toast = useToast()
        toast.error(`填充失败: ${error.message}`)
      }
    },
    
    /**
     * 根据选择的动物填充答案
     */
    fillWithAnimal() {
      if (!this.selectedAnimal) {
        const toast = useToast()
        toast.warning('请先选择动物')
        return
      }
      
      try {
        const newAnswers = generateAnswersForAnimal(this.selectedAnimal)
        this.$emit('update-answers', newAnswers)
        
        const toast = useToast()
        toast.success(`已根据 ${this.getAnimalEmoji(this.selectedAnimal)} ${this.selectedAnimal} 填充答案`)
      } catch (error) {
        const toast = useToast()
        toast.error(`填充失败: ${error.message}`)
      }
    },
    
    /**
     * 快速提交
     */
    quickSubmit() {
      if (this.answeredCount < 60) {
        const toast = useToast()
        toast.warning(`还有 ${60 - this.answeredCount} 道题未作答`)
        return
      }
      
      this.$emit('submit')
    }
  }
}
</script>

<style scoped>
/* 组件样式 */
</style>

